var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","offset-md":"2"}},[_c('v-card',[_c('v-card-text',{staticClass:"pa-0"},[_c('v-alert',{staticClass:"error__alert",attrs:{"type":"error"}},[_vm._v("\n            Cтраница не найдена\n          ")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }